import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Avatar, Dropdown, Menu, Modal } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PoweroffOutlined,
  UserOutlined,
  AlertOutlined,
  WarningOutlined,
  ExclamationCircleOutlined
} from "@ant-design/icons";
import KiconexLogo from "../../assets/img/png/logo.png";
import service from "../../services/Service";
import "./MenuTop.scss";
import { useSelector, useDispatch } from 'react-redux';
import { logout, impersonate } from "../../api/user";
import { withLocale } from "../../l10n";
import { getTokenInfo, hasPrivilege } from "../../api/token";
import { 
  saveExpiredM2MSubscriptions, 
  saveExpiredPlanSubscriptions, 
  saveM2MInfo 
  // , savePendingInfo
} from "../../store"; 
import { 
  REFRESH_INTERVAL_M2M_ALARMS_MILISECONDS, 
  REFRESH_INTERVAL_RENEWALS_MILISECONDS, 
  REFRESH_INTERVAL_VERSION_MILISECONDS 
} from "../../utils/constants";

export let globalInterval = null;
export function setGlobalInterval(value) {
  globalInterval = value;
}

function MenuTop(props) {
  const { menuCollapsed, setMenuCollapsed, homeUrl, lang} = props;
  const navigate = useNavigate();
  const store = useSelector(state => state.store);
  const dispatch = useDispatch();
  const itemsActived = [];
  const items = {
    expired_m2m_subscriptions: {
      key: "1",
      icon: <WarningOutlined />,
      label: 
        <Link 
          to={"/boards/renewals"} 
          style={{ textDecoration: 'none' }} 
          state={{ plan: store.alerts.expired_m2m_subscriptions.expired_plan }}
        >
          <span className="nav-text"> 
            {lang.handle('Renovaciones M2M expiradas')} 
          </span>
        </Link>,
      danger: true,
    },
    expired_plan_subscriptions: {
      key: "2",
      icon: <WarningOutlined />,
      label: 
        <Link 
          to={"/boards/renewals"} 
          style={{ textDecoration: 'none' }} 
          state={{ plan: store.alerts.expired_plan_subscriptions.expired_plan }}
        >
          <span className="nav-text"> 
            {lang.handle('Renovaciones de plan expiradas')} 
          </span>
        </Link>,
      danger: true,
    },
    // pending_info: {
    //   key: "2",
    //   icon: <WarningOutlined />,
    //   label: <Link to={"/orders/list"} style={{ textDecoration: 'none' }} state={{ filter: store.alerts.pending_info.visible }}><span className="nav-text"> {lang.handle('Pedidos pendientes')} </span></Link>,
    //   danger: true,
    // },
    alarms_m2m: {
      key: "3",
      icon: <WarningOutlined />,
      label: <Link to={"/simcards/m2m"} style={{ textDecoration: 'none' }} state={{ filter: store.alerts.alarms_m2m.filter }}><span className="nav-text"> {lang.handle('Alarmas M2M')} </span></Link>,
      danger: true,
    }
  }

  const logoutUser = async () => {
    const result = await logout();
    if (result) navigate(0);
  };

  // eslint-disable-next-line
  const handleClick = React.useCallback((e) => {
    localStorage.setItem("langCode", e.key);
    navigate(0);
  })

  const editProfile = () => {
    navigate(`/users/edit/${getTokenInfo().uuid}`);
  }

  const backSession = async () => {
    await impersonate(getTokenInfo().oldUser.uuid);
  };

  const functions = {
    expired_m2m_subscriptions: async function expiredM2MSubscriptions() {
      if (hasPrivilege('renewal_view')) {
        try {
          const res = await service.get("m2m-subscriptions/expired");

          if (res?.status === 200) {
            if (res.data.data) {
              dispatch(saveExpiredM2MSubscriptions({ visible: true, expired_plan: 'm2m' }));
            } else {
              dispatch(saveExpiredM2MSubscriptions({ visible: false }));
            }
          }
        } catch (err) {
          console.log("Error devuelto: " + err);
        }
      }
    },
    expired_plan_subscriptions: async function expiredPlanSubscriptions() {
      if (hasPrivilege('renewal_view')) {
        try {
          const res = await service.get("plan-subscriptions/expired");

          if (res?.status === 200) {
            if (res.data.data) {
              dispatch(saveExpiredPlanSubscriptions({ visible: true, expired_plan: 'plan' }));
            } else {
              dispatch(saveExpiredPlanSubscriptions({ visible: false }));
            }
          }
        } catch (err) {
          console.log("Error devuelto: " + err);
        }
      }
    },
    // pending_info: async function pendingOrders() {
    //   if (hasPrivilege('orders_view')) {
    //     await service.get("orders/pending").then((res) => {
    //         if (res.status === 200) {
    //           res.data.length <= 0 ? dispatch(savePendingInfo({pending: {visible: false}})) : dispatch(savePendingInfo({pending: {visible: true}}));
    //         }
    //     }).catch((err) => {
    //         console.log("Error devuelto: " + err);
    //     });
    //   }
    // },
    alarms_m2m: async function alarmsM2MActived() {
      if (hasPrivilege('m2m_view')) {
        const tenant_uuid = getTokenInfo().tenant_uuid;
        let alarmsActived = false;
        const params = {
          tenant_uuid: tenant_uuid,
        }

        const alarms = await service.get('m2m', params).then((res) => {
            if (res.status === 200) {
              for (const element of res.data) {
                if (element.alarms.length >= 1 && element.alarms[0] !== 0) {
                  alarmsActived = true;
                }
              }
              return alarmsActived;
            }
        }).catch((err) => {
            console.log("Error devuelto: " + err);
        });

        const risk = await service.get('m2m/deleted-risk', params).then((res) => {
          if (res.status === 200) {
            return res.data.length > 0;
          }
        }).catch((err) => {
          console.log("Error devuelto: " + err);
        });

        let result = { alarmsActived: { } };
        result.alarmsActived.visible = alarms || risk;
        result.alarmsActived.filter = alarms;

        dispatch(saveM2MInfo(result));
      }
    },
    version: async function version() {
      await service.get("system/version").then((res) => {
          if (res.status === 200) {
            if (!res.data.is_valid) {
              Modal.confirm({
                title: lang.handle("Su sesión va a ser cerrada"),
                content: lang.handle("Posee una versión no compatible"),
                icon: <ExclamationCircleOutlined />,
                cancelButtonProps: { disabled: true, style: { display: 'none' } },
                onOk: () => { logoutUser(); },
              });
            }
          }
      }).catch((err) => {
          console.log("Error devuelto: " + err);
      });
    },
  }

  useEffect(() => {
    if (localStorage.getItem('disableInterval') === 'true') return;
    
    functions.version();
    functions.expired_m2m_subscriptions();
    functions.expired_plan_subscriptions();
    // functions.pending_info();
    functions.alarms_m2m();
    
    globalInterval = setInterval(() => {
      functions.alarms_m2m();
    }, REFRESH_INTERVAL_M2M_ALARMS_MILISECONDS);

    const interval_renewals = setInterval(() => {
      functions.expired_m2m_subscriptions();
      functions.expired_plan_subscriptions();
      // functions.pending_info();
    }, REFRESH_INTERVAL_RENEWALS_MILISECONDS);

    const interval_version = setInterval(() => {
      functions.version();
    }, REFRESH_INTERVAL_VERSION_MILISECONDS);

    return () => { 
      clearInterval(globalInterval); 
      clearInterval(interval_renewals);
      clearInterval(interval_version); 
    };
  // eslint-disable-next-line
  }, [])

  Object.entries(store.alerts).forEach(([key, value]) => {
    if (value.visible) {
      itemsActived.push(items[key]);
    }
  })

  return (
    <div className="menu-top">
      <div className="menu-top__left">
        <Link to={homeUrl}>
          <img
            className="menu-top__left-logo"
            src={KiconexLogo}
            alt="Kiconex"
          />
        </Link>
        <Button type="link" onClick={() => setMenuCollapsed(!menuCollapsed)}>
          {menuCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </Button>
      </div> 



      <div className="menu-top__right d-flex align-items-center h-100 w-25" style={{justifyContent: 'space-between'}}>
        <div style={{flex: 1, display: 'flex', justifyContent: 'center'}}>
          {hasPrivilege('translator_view') &&
            <Button className="translator-button" color="default" variant="outlined" onClick={() => navigate('/translator')}>
              {lang.handle('Traductor de librerías')}
            </Button>
          }
        </div>
        <div style={{display: 'flex', alignItems: 'center'}}>
          { getTokenInfo().oldUser &&
          <div className="impersonateBanner">
            {lang.handle('Personificando al usuario')} {getTokenInfo().username} <button onClick={backSession}>{lang.handle('Volver a la sesión')}</button>
          </div>
          }
          {
          itemsActived.length >= 1 ? (
          <Dropdown overlay={
              <Menu items={itemsActived}/>
          }>
            <AlertOutlined style={{color: 'red', marginRight: '15px'}}/>
          </Dropdown>
          ): null}
          <Dropdown 
            overlay={
              <div className="main">
              {/* <EditOutlined /> */}
              <div className="profile">
                <Avatar size="large" icon={<UserOutlined />} />
                <h5>{getTokenInfo().username}</h5>
                <h5>{getTokenInfo().email}</h5>
                <Button className="gestButton" onClick={editProfile}>{lang.handle("Gestionar perfil")}</Button>
              </div>
              <div className="profile-options">
                <Menu
                  onClick={handleClick}
                  items={[
                    {
                      key:'1',
                      label: lang.handle('Seleccionar idioma'),
                      children: [
                        {
                          key:'es',
                          label: lang.handle('Español'),
                        },
                        {
                          key:'en',
                          label: lang.handle('Inglés'),
                        },
                        {
                          key:'fr',
                          label: lang.handle('Francés'),
                        },
                        {
                          key:'de',
                          label: lang.handle('Alemán'),
                        },
                        {
                          key:'pt',
                          label: lang.handle('Portugués'),
                        },
                        {
                          key:'it',
                          label: lang.handle('Italiano'),
                        }
                      ]
                    },
                  ]}>
                </Menu>
                <Button type="link" onClick={logoutUser} className="btnLogout">
                  <PoweroffOutlined/>
                </Button>
              </div>
            </div>
          }
          trigger={['click']}>
            <Avatar icon={<UserOutlined />} />
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

export default withLocale(MenuTop);
